import * as React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useEffect, useState } from 'react'
import Table, { ColumnDescription } from 'react-bootstrap-table-next'

import TableItem from '../../ui/table/tableItem'
import { BlacklistItem, FolloweeItem, FollowerItem } from '../../../store/member/memberTypings'

import './table.sass'
import s from '../../profile/materials/materialPreview.module.sass'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import { useHistory } from 'react-router-dom'

interface Props {
    listLength: number
    title: string
    followees?: FolloweeItem[]
    followers?: FollowerItem[]
    columns: ColumnDescription[]
    blacklistItems?: BlacklistItem[]
    favorite?: boolean
}

const UsersTable: React.FunctionComponent<Props> = ({
    listLength,
    title,
    columns,
    followers = [],
    followees = [],
    blacklistItems = [],
    favorite = false
}: Props) => {
    const [desktop, setDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1024 : false)

    const history = useHistory()
    const checkWidth = (): void => {
        if (typeof window !== 'undefined') {
            const updatedDesktop = window.innerWidth >= 1024
            if (desktop !== updatedDesktop) setDesktop(updatedDesktop)
        }
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', checkWidth)
        }
        return () => window.removeEventListener('resize', checkWidth)
    })

    const rowEvents = {
        //@ts-ignore
        onClick: (e, row) => {
            const userNick = row['followee']
                ? row['followee'].nick
                : row['follower']
                ? row['follower'].nick
                : row['banned_user'].nick
            history.push(createLocalizedPath(paths.profile.toPath({ nick: userNick })))
        }
    }

    // @ts-ignore
    const renderDesktop = () => {
        if (!isEmpty(followers)) {
            return <Table data={followers} keyField="follower_id" columns={columns} rowEvents={rowEvents} />
        }
        if (!isEmpty(followees)) {
            return <Table data={followees} keyField="followee_id" columns={columns} rowEvents={rowEvents} />
        }
        if (!isEmpty(blacklistItems)) {
            return (
                <Table data={blacklistItems} keyField="blacklisted_user_id" columns={columns} rowEvents={rowEvents} />
            )
        }
    }

    // @ts-ignore
    const renderMobile = () => {
        if (!isEmpty(followers)) {
            return (
                <div className="mobile">
                    {followers.map((follower: FollowerItem) => (
                        <TableItem follower={follower} key={follower.follower_id} />
                    ))}
                </div>
            )
        }
        if (!isEmpty(followees)) {
            return (
                <div className="mobile">
                    {followees.map((followee: FolloweeItem) => (
                        <TableItem followee={followee} key={followee.followee_id} favorite={favorite} />
                    ))}
                </div>
            )
        }
        if (!isEmpty(blacklistItems)) {
            return (
                <div className="mobile">
                    {blacklistItems.map((blacklistItem: BlacklistItem) => (
                        <TableItem blacklistItem={blacklistItem} key={blacklistItem.blacklisted_user_id} />
                    ))}
                </div>
            )
        }
    }

    return (
        <div className="tableContainer">
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__title']}>{title}</div>
                <div className={s['materialsPreview__counter']} data-testid={'listLength'}>
                    {!favorite && listLength}
                </div>
            </div>
            {desktop ? renderDesktop() : renderMobile()}
        </div>
    )
}

export default UsersTable
